<template>
<div class="tes-card pa-7">
    <div class="tes-debt">
 <div class="form-epd__trasparant" v-if="!successApplication">
                <p class="font-weight-medium mb-5 "
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('client')}}</p>
                <p class="mb-5 mt-5" :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">{{$t('pages.certificateOfDebt.limitInfo')}}</p>
                    <a href="https://lkfl.tatenergosbyt.ru/docs/Инструкция_для_клиента_ЛК.pdf" target="blank">{{$t('pages.certificateOfDebt.infoLink')}} →</a>
 </div>
   <v-row>
      <v-col>
        
        <h1 class="tes-card__title">{{$t('pages.certificateOfDebt.title')}}</h1>

        <div v-if="!successApplication">
        <p class="mt-5 font-weight-medium mt-4 mb-0"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('client')}}</p>
        <p class="mb-0 mt-5 textheader"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
        {{$t('pages.certificateOfDebt.info')}}</p>

            <v-row class="mt-7">
            <v-col
                :cols="12"
                :sm="4"
                :md="3"
                :lg="2"
                :xl="2"
                class="col col-title">{{$t('personalAccount')}}:</v-col>
            <v-col
                class="col"
                :cols="12"
                :sm="8"
                :md="7"
                :lg="5"
                :xl="6">
                <personal-account-select
                    v-model="selectedAccount"
                    :is-local="true"
                    :only-is-owner="true"
                    :disabled="loading">
                </personal-account-select>
            </v-col>
            </v-row>

            <v-row>
            <v-col
                :cols="12"
                :sm="4"
                :md="3"
                :lg="2"
                :xl="2"
                class="col col-title">{{$t('email')}}:
                <sup class="star">*</sup>
                </v-col>
            <v-col
                class="col"
                :cols="12"
                :sm="8"
                :md="7"
                :lg="5"
                :xl="6">
            <v-text-field
            v-model="email"
            :rules="emailRules"
            outlined
            required
            :disabled="loading"></v-text-field>
            </v-col>
            </v-row>
            
            <v-row>
            <v-col
                :cols="12"
                :sm="4"
                :md="3"
                :lg="2"
                :xl="2"
                class="col col-title">{{$t('pages.certificateOfDebt.period')}}:
                <sup class="star">*</sup>
                </v-col>
            <v-col
                class="col"
                :cols="12"
                :sm="8"
                :md="7"
                :lg="5"
                :xl="6">
        <input-month-picker
            class="date-interval-field__input px-0"
            key="from"
            v-model="debtDate"
            :disabled ="loading" />
         </v-col>
            </v-row>
            <v-row>
                <v-col :cols="6">
                <p class="mb-0 mt-5"
                :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
                <sup class="star">* - {{$t('fieldRequire')}}</sup>
                </p>
                </v-col>
                
                <v-col class="text-right" :cols="6">
                    <v-btn
                        @click="back"
                        class="btn btn--white"
                        :loading="loading">{{$t('buttons.cancel')}}</v-btn>
                    <v-btn
                        @click="save"
                        :disabled="!isValid"
                        class="btn btn--green"
                        :loading="loading">{{$t('buttons.save')}}</v-btn>
                </v-col> 
            </v-row>
            </div>
            <div v-if="!checkApplicationDebt && successApplication">
                <p class="mb-0 mt-5"
                        :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
                    {{$t('pages.certificateOfDebt.requestAccept')}}</p>
            </div>
            <div v-if="checkApplicationDebt">
             <p class="mb-0 mt-5"
             :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
             
               <strong class="red--text"> {{$t('pages.certificateOfDebt.warning')}}</strong> {{$t('pages.certificateOfDebt.requestNotAccept').split('_')[0]}}
                {{domHoz}} {{$t('pages.certificateOfDebt.requestNotAccept').split('_')[1]}}</p>
            </div>
            
      </v-col>
    </v-row>   
    </div>
    </div>
</template>

<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import ChangeTariffNotification from '../../../components/statements/change-tariff-electricity/ChangeTariffNotification.vue';
import { mapState, mapGetters } from "vuex";
import InputDatePicker from '../../../components/common/InputDatePicker'
import InputMonthPicker from "../../../components/common/InputMonthPickerLimit";

export default {
    layout: "main",
    components: {
        PersonalAccountSelect,
        ChangeTariffNotification,
        InputDatePicker,
        InputMonthPicker
    },
    data: () => ({
        alert: false,
        checkApplicationDebt: false,
        email: "",
        selectedAccount: null,
        loading: false,
        debtDateYear: null,
        debtDateMonth: null,
        debtDate: null,
        domHoz: null,
        debtDateDay: null,
        successApplication: false,
    }),            
    created() {
        
      if (this.userSettings) {
        let date= "" + new Date().getFullYear();
        
        this.email = this.userSettings.email;
        this.debtDate = date;
      }},
    methods: {

        back() {
            this.$router.push('/')
        },
        save(){

            let postData ={
                email: this.email,
                domHoz: this.selectedAccount.domHoz,
                date: this.debtDate,
                userId: this.$store.state.account.userSettings.userGuid
            };
                        this.loading = true;
            this.$store
                .dispatch("statements/setApplicationForDebt", postData)
                .then(result => {
                    this.loading = false;
                    if (result.success || result.checkApplicationDebt) {
                        this.successApplication = true;
                        this.checkApplicationDebt = result.checkApplicationDebt;
                        this.domHoz = result.domhoz;           
                    }
                });
        },

    },
    computed: {
        ...mapState("account", ["actualPhones"]),
        ...mapGetters("locale",["currentLocale"]),
        
    userSettings() {
      return { ...this.$store.getters["account/userSettings"] };
    },
    isValid: function () {
        return  (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(this.email)&&this.debtDate);
    },
    emailRules() {
        return [
        v => !!v || this.$t('rules.inputEmail'),
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('rules.incorrectEmail')
        ]
      }
    },
    watch: {
    },
};
</script>

<style lang="scss" scoped>
.change-tariff-electricity {
    width: 100%;
    position: relative;
    padding: 23px 17px 23px 22px;
    background-color: white;
    border-radius: 5px;

    &__br {
        display: block;
        font-size: 20px;
    }

    &__title {
        @extend %h1;
    }

    &__title-2 {
        color: #333333;
        font-weight: bold;
        font-size: 18px;
        margin-top: 30px;
        margin-bottom: 22px;
    }

    &__important {
        display: block;
        @extend %important-text;
    }

    &__text {
        display: block;
        @extend %text;
        font-style: italic;
    }

    &__marker {
        display: block;
        @extend %marker-text;
        margin-bottom: 21px;
    }

    &__form {
        position: relative;
        width: 100%;
    }
}

.btn {
    &--blue {
        @extend %b-btn;
        margin: 8px 8px 8px 0;
    }

    &--white {
        @extend %w-btn;
        margin: 8px 0 8px 8px;
    }

    &--green {
        @extend %g-btn;
        margin: 8px 0 8px 16px;
    }
}

.divider {
    background: #999;
}

.star {
    color: #ff9933;
}

.radio-btns-title,
.col col-title {
    font-weight: 500;
    font-size: 18px;
    color: #4d4d4d;
}

.radio-btns-title {
    display: block;
    margin: 25px 0;
}

.radio-btns {
    margin-bottom: 30px;
}

.radio-btns-info {
    display: block;
    @extend %marker-text;
    color: $main-orange;
    margin-top: 21px;
}

.col {
    padding: 0 12px;

    &-title {
        @extend %important-text;
        width: 300px;
        align-self: center;
        margin-bottom: 30px;
    }
}

.row-phone {
    margin: 30px 0 12px 0;
}

.v-radio {
    margin-right: 0;

    &+& {
        margin-top: 7px;
    }
}

.col-alert {
    display: flex;
    align-items: center;

    &-text {
        margin-left: 10px;
        color: white;
    }

    &-right {
        justify-content: flex-end;
    }
}
.abso{
    position: relative;
}
.form-epd__trasparant {
        position: absolute;
        width: 25%;
        right: 8%;
        padding: 16px;
        font-size: 14px;
        font-weight: 300;
        border-radius: 16px;
        border: 1px solid #ff721c;

        @media screen and (max-width: 1400px) {
         position: relative;
         width: 100%;
         right: 0%;
         
        }
      }
       .textheader{
                @media screen and (max-width: 1500px) {
         width: 50%;
         
        }
        }
</style>
